import { useAuthStore } from '../stores/authStore';
import type { Module, Action } from '../lib/types';

export function useCan(module: Module, action: Action): boolean {
  return useAuthStore(s => {
    const user = s.user;
    if (!user) return false;
    if (!user.active) return false;
    if (user.role === 'blocked') return false;
    if (user.role === 'admin') return true;
    return user.permissions?.[module]?.[action] === true;
  });
}
